import { contacts, phoneNumber } from "../../data";
import IconsProps from "../Props/IconsProps";

function ContactNavigation() {
  return (
    <>
      <section className="contact-navigation container">
        <div className="social-media">
          <IconsProps data={contacts} />
        </div>
        <div className="phone">
          <IconsProps data={phoneNumber} />
        </div>
      </section>
      <section className="contact-navigation-mobile">
        <div className="contact-navigation-mobile-sm">
          <IconsProps data={contacts} />
          <IconsProps data={phoneNumber} />
        </div>
      </section>
    </>
  );
}

export default ContactNavigation;
